
    <div class="coupon-banner" [ngClass]="{ 'coupon-active': showBanner && this.coupon }">
      <span class="coupon-title">{{ brandData?.mainProduct | titlecase }} Savings!</span>
      <p class="coupon-message" [innerHTML]="coupon?.bannerMessage"></p>
      <span class="close-icon" (click)="closeBanner()">X</span>
    </div>
  